import {
  CustomGetOrganizationUsersQuery,
  CustomGetOrganizationUsersQueryVariables,
  useCustomGetOrganizationUsersLazyQuery,
} from "generated/graphql";
import { useCallback } from "react";

type OrganizationUsersLazyQueryData = CustomGetOrganizationUsersQuery;

export default function useGetOrganizationUsersLazy() {
  const [getOrganizationUsersLazyQuery, queryState] = useCustomGetOrganizationUsersLazyQuery();

  const getOrganizationUsers = useCallback(
    ({
      page,
      first,
      search,
      status,
      roles,
    }: CustomGetOrganizationUsersQueryVariables) => {
      getOrganizationUsersLazyQuery({
        variables: {
          page,
          first,
          search,
          status,
          roles,
        },
      });
    },
    [getOrganizationUsersLazyQuery]
  );

  const data = queryState.data as OrganizationUsersLazyQueryData | undefined;
  const users = data?.getOrganizationUsers?.data ?? [];
  const paginatorInfo = data?.getOrganizationUsers?.paginatorInfo ?? null;
  const totalUsers = data?.getOrganizationUsers?.paginatorInfo?.total || null;

  return [
    getOrganizationUsers,
    { data, loading: queryState.loading, error: queryState.error, users, paginatorInfo, totalUsers },
  ] as const;
}
